import { Badge, BadgeProps } from './Badge';
import BadgeDropdown from './variants/BadgeDropdown';
import BadgePopover from './variants/BadgePopover';
import BadgeTag from './variants/BadgeTag';
import BadgeValue from './variants/BadgeValue';

export { Badge, BadgeValue, BadgeTag, BadgeDropdown, BadgePopover };
export type { BadgeProps };
